var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewListingsCoinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C2.85533 0 0 1.53733 0 3.5V6.83333C0 8.992 2.49067 10.3333 6.5 10.3333C10.5093 10.3333 13 8.992 13 6.83333V3.5C13 1.53733 10.1447 0 6.5 0ZM6.5 1C9.74133 1 12 2.31733 12 3.5C12 4.68267 9.74133 6 6.5 6C3.25867 6 1 4.68267 1 3.5C1 2.31733 3.25867 1 6.5 1ZM6 6.98665V9.32467C5.20867 9.298 4.39867 9.20599 3.66667 9.03333V6.65735C4.37867 6.83935 5.164 6.95399 6 6.98665ZM7 6.98665C7.836 6.95399 8.62133 6.83935 9.33333 6.65735V9.03333C8.60133 9.20533 7.79133 9.29733 7 9.32467V6.98665ZM1 6.83333V5.38399C1.43733 5.75866 2.00267 6.08201 2.66667 6.34001V8.72066C1.68133 8.324 1 7.716 1 6.83333ZM10.3333 8.72066V6.34001C10.9973 6.08201 11.5627 5.75866 12 5.38399V6.83333C12 7.716 11.3187 8.324 10.3333 8.72066Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewListingsCoinIcon);
export default __webpack_public_path__ + "static/media/new-listings-coin-icon.e1b3172e1cae0fb2d5caef4cd0b26e4b.svg";
export { ForwardRef as ReactComponent };